import { notify } from '@kyvg/vue3-notification'
import { i18n } from '~/libs'
import { resolveAdminErrorMessage } from '~/utils/admin-error-message'

function adminTranslate(key: string): string {
  return (i18n.global as unknown as { t: (k: string) => string }).t(key)
}

export function $e(ex: any, title: string | null = null) {
  notify({
    text: resolveAdminErrorMessage(ex),
    title: title == null ? adminTranslate('common.error') : title,
    type: 'error',
  })
}

/** Admin POST endpoints return `message` as base64-encoded UTF-8. */
export function decodeAdminBase64Message(encoded: string | undefined): string {
  if (!encoded)
    return ''

  try {
    const binary = atob(encoded)
    const bytes = Uint8Array.from(binary, char => char.charCodeAt(0))
    return new TextDecoder().decode(bytes)
  }
  catch {
    return encoded
  }
}

export function $s(message: string, title: string | null = null) {
  if (title == null) {
    title = adminTranslate('common.success')
  }

  notify({
    text: message,
    title,
    type: 'success',
  })
}
